// extracted by mini-css-extract-plugin
export default {"container":"hhx4Q06kZNjJPdZOZzPh","fullWidth":"koe2Vi_e0ethbMDcjVcM"};